<template>
  <div class="box py-2 company-classification" dir="rtl" data-test="company-classification">
    <div class="is-flex is-align-items-center is-flex-wrap-wrap">
      <label class="checkbox ml-4" data-test="top-firm-field">
        <input type="checkbox" :checked="form.is_top_firm" :disabled="saving" data-test="top-firm-input" @change="save('is_top_firm', $event.target.checked)" />
        פירמה מובילה
      </label>
      <span class="has-text-weight-bold ml-2">יוקרה:</span>
      <div class="select is-small ml-4">
        <select :value="form.prestige || ''" :disabled="saving" data-test="prestige-select" @change="save('prestige', $event.target.value || null)">
          <option value="">—</option>
          <option v-for="o in prestigeOptions" :key="o.value" :value="o.value">{{ o.label }}</option>
        </select>
      </div>
      <span class="has-text-weight-bold ml-2">סוג מעסיק:</span>
      <div class="select is-small">
        <select :value="form.employer_kind || ''" :disabled="saving" data-test="employer-kind-select" @change="save('employer_kind', $event.target.value || null)">
          <option value="">—</option>
          <option v-for="o in employerKindOptions" :key="o.value" :value="o.value">{{ o.label }}</option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
export const PRESTIGE_OPTIONS = [
  { value: 'top', label: 'טופ' },
  { value: 'high', label: 'גבוהה' },
  { value: 'regular', label: 'רגילה' }
]
export const EMPLOYER_KIND_OPTIONS = [
  { value: 'law_firm', label: 'משרד עו"ד' },
  { value: 'company', label: 'חברה' },
  { value: 'accounting_firm', label: 'פירמת רו"ח' },
  { value: 'in_house', label: 'יועמ"ש בחברה' }
]

// VA2 - top firm / prestige / employer kind, saved on change through the
// existing company update. When the passed company lacks the fields (e.g. a
// company nested in a position), the full company is fetched once.
export default {
  name: 'CompanyClassification',
  props: {
    company: { type: Object, required: true }
  },
  data () {
    return {
      prestigeOptions: PRESTIGE_OPTIONS,
      employerKindOptions: EMPLOYER_KIND_OPTIONS,
      form: this.pick(this.company),
      saving: false
    }
  },
  computed: {
    companyId () {
      return this.company.resource_id || this.company.id || null
    }
  },
  watch: {
    // only fields the new object actually carries, so a partial company
    // (no classification keys) does not wipe what refresh() loaded
    company (c) {
      const next = this.pick(c)
      const known = Object.keys(next).filter(k => c && c[k] !== undefined)
      known.forEach(k => { this.form = { ...this.form, [k]: next[k] } })
    }
  },
  created () {
    if (this.company.is_top_firm === undefined && this.companyId) this.refresh()
  },
  methods: {
    pick (c) {
      c = c || {}
      return { is_top_firm: c.is_top_firm === true || c.is_top_firm === 1, prestige: c.prestige || null, employer_kind: c.employer_kind || null }
    },
    async refresh () {
      try {
        const fresh = await this.$network_utils.getCompany({ id: this.companyId })
        if (fresh) this.form = this.pick(fresh)
      } catch (e) {
        // keep the defaults; the fields stay editable
      }
    },
    async save (field, value) {
      if (!this.companyId) return
      const previous = this.form[field]
      this.form = { ...this.form, [field]: value }
      this.saving = true
      try {
        await this.$network_utils.updateCompany({ id: this.companyId, [field]: value })
        this.$emit('updated', { [field]: value })
        this.$utils.emit('show_toast', { text: 'נשמר' })
      } catch (e) {
        this.form = { ...this.form, [field]: previous }
        this.$utils.emit('show_toast', { text: 'השמירה נכשלה - נסו שוב' })
      } finally {
        this.saving = false
      }
    }
  }
}
</script>
